module.exports = __webpack_public_path__ + "static/media/atrium-4.14ebb083.jpg";